import React, { useEffect, useState } from "react";
import { useForm } from "@mantine/form";
import { TextInput, Button, Group, Box, ColorInput } from "@mantine/core";
import HttpClient from "../helpers/HttpClient";
import { useNavigate } from "react-router-dom";
import { Tag } from "../types/tag.type";

const TagEdit: React.FC<{ id: number | undefined }> = ({ id }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const navigate = useNavigate();
  const httpClient = new HttpClient<Tag>("/tag");

  const form = useForm<Tag>({
    initialValues: {
      id: 0,
      name: "",
      color: "#ffffff",
    },
    validate: {
      name: (value) => (value ? null : "Tag name is required"),
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (id) {
          const result: any = await httpClient.getById(Number(id));
          const tag = result.data as Tag;
          form.setValues(tag);
          setIsUpdate(true);
        }
      } catch (error) {
        console.error("Failed to fetch tag", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  const onSubmit = async (values: Tag) => {
    try {
      const response = await httpClient.post(values);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to submit form");
      }
      navigate(-1);
    } catch (error) {
      alert("Tag could not be updated/saved! " + error);
    }
  };

  const onDelete = async () => {
    try {
      if (!id) {
        throw new Error("Failed to delete Tag without id");
      }
      const response = await httpClient.delete(Number(id));
      if (response.status !== 200) {
        throw new Error("Failed to delete Tag");
      }
      navigate(-1);
    } catch (error) {
      alert(error as string);
    }
  };

  return (
    <Box mx="auto">
      <form onSubmit={form.onSubmit((values) => onSubmit(values))}>
        <TextInput label="Tag Name" {...form.getInputProps("name")} />
        <ColorInput format="hex" {...form.getInputProps("color")} />

        <Group mt="md">
          <Button type="submit">Save</Button>
          {isUpdate && <Button type="button" color="red" onClick={onDelete}>Delete</Button>}
        </Group>
      </form>
    </Box>
  );
};

export default TagEdit;
